export const getSurveyAnswers = state => state?.surveyAnswers